// extracted by mini-css-extract-plugin
export var fadeInOut = "_3q-3";
export var icon = "_3q-4";
export var savedIndicator = "_3q-2";
export var savingIndicator = "_3q-0";
export var spin = "_3q-1";